import { Injectable } from '@angular/core';

@Injectable()
export abstract class ContextService {
  /**
   * This method must be overriden - in order to load an app specific environment.
   */
  public abstract getContext();

  public abstract isLocalEnv(): boolean;

  /* eslint-disable no-restricted-globals */
  private getHost(): string {
    return window.location.host;
  }

  private getPath(): string {
    return window.location.pathname;
  }
  /* eslint-enable no-restricted-globals */

  //public abstract getBaseUrl(url: string): URL;
  public abstract getBaseUrl(url: string): HTMLAnchorElement;
}
